import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query";

import {
  RegisterRequest,
  SendCodeRequest,
  VerifyCodeRequest,
  SetPasswordRequest,
  VerifyPatientRequest,
  CheckForMatchesRequest,
} from "api/types/requests";
import { MatchResponse } from "api/types/responses";
import User from "api/types/models/user";
import QueryTags from "api/types/QueryTags";

const registerEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      {},
      FetchBaseQueryMeta
    >,
    QueryTags,
    "data"
  >,
) => ({
  checkForMatches: builder.mutation<MatchResponse, CheckForMatchesRequest>({
    query: (body) => ({
      url: "/auth/register/match",
      method: "post",
      body,
    }),
  }),

  register: builder.mutation<User, RegisterRequest>({
    query: (body) => ({
      url: "/auth/register",
      method: "post",
      body,
    }),
  }),

  sendCode: builder.mutation<void, SendCodeRequest>({
    query: (body) => ({
      url: "/auth/register/code",
      method: "post",
      body,
    }),
  }),

  verifyCode: builder.mutation<User, VerifyCodeRequest>({
    query: (body) => ({
      url: "/auth/register/verify",
      method: "post",
      body,
    }),
  }),

  verifyPatient: builder.mutation<User, VerifyPatientRequest>({
    query: (body) => ({
      url: "/auth/register/patient",
      method: "post",
      body,
    }),
  }),

  setPassword: builder.mutation<User, SetPasswordRequest>({
    query: (body) => ({
      url: "/auth/register/password",
      method: "post",
      body,
    }),
  }),
});

export default registerEndpoints;
